export const COLORS_CHART = [
  "#34c38f",
  "#556ee6",
  "#f46a6a",
  "#50a5f1",
  "#f1b44c",
  "#b644b8fa",
];

export const ALL_STORE = "ALL_STORE";
